import Link from 'next/link';
import {useMobileOrTablet} from '@helpers/hooks/useWindow';
import {BiChevronRight} from '@assets/react-icons/bi';

export const Breadcrumbs = ({
  sku,
  categoryName,
  categoryLink,
  collectionLink,
  collectionName,
  excludeCategoryLevel = false
}) => {
  const isMobile = useMobileOrTablet();
  const fontSize = '14px';

  categoryLink =
    categoryLink && categoryLink?.startsWith('/collections')
      ? categoryLink
      : `/collections/${categoryLink}`;
  categoryLink = categoryLink?.replaceAll('//', '/');

  if (isMobile && categoryName === 'Vehicle Specific Enclosures') {
    categoryName = 'Vehicle Specific';
  }
  // console.log('[Breadcrumbs]:', {categoryName, categoryLink, collectionLink, collectionName, sku});

  return (
    <nav
      className="flex items-center mb-1"
      style={{
        fontFamily: 'Helvetica',
        fontSize: fontSize,
        color: 'rgb(109, 109, 109)'
      }}
      aria-label="Breadcrumb">
      <ol className="inline-flex gap-1.5 pt-1 leading-4">
        <li>
          <Link href="/">Home</Link>
        </li>

        {categoryName && categoryLink && !excludeCategoryLevel && (
          <li>
            <div className={'flex items-center'}>
              <BreadcrumbSeparator />
              <Link
                href={categoryLink}
                className="ml-0.5 whitespace-pre"
                aria-label={`Parent category ${categoryName} ${sku ? `for ${sku}` : ''}`}>
                {categoryName}
              </Link>
            </div>
          </li>
        )}

        {collectionLink && collectionName && (
          <li>
            <div className={'flex items-center'}>
              <BreadcrumbSeparator />
              <Link
                href={collectionLink}
                className="ml-0.5 md:ml-2 whitespace-pre"
                aria-label={`Parent collection: ${collectionName} ${sku ? `for ${sku}` : ''}`}>
                {collectionName}
              </Link>
            </div>
          </li>
        )}

        {sku && (
          <li aria-current="page" className={'flex items-center'}>
            <BreadcrumbSeparator />
            <div className="ml-0.5 text-gray-500 md:ml-1">{sku}</div>
          </li>
        )}
      </ol>
    </nav>
  );
};

const BreadcrumbSeparator = () => {
  return (
    <div className="w-[7px] h-[13px] text-gray-500">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.115 18" fill="currentColor">
        <path d="M2.115 0 0 2.115 6.87 9 0 15.885 2.115 18l9-9Z" />
      </svg>
    </div>
  );
};
